import { Skeleton, SkeletonText } from "../ui/feedback";
import { Panel } from "../ui/panel";
import "../../styles/components/layout.css";

/** 页面级加载骨架（路由懒加载时的 Suspense fallback）：与真实页面同构，避免布局跳动 */
export default function PageSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="page-skeleton" aria-busy="true" aria-label="页面加载中">
      <div className="page-skeleton-head">
        <Skeleton width={132} height={12} />
        <Skeleton width={230} height={26} />
        <Skeleton width={320} height={13} />
      </div>
      <div className="page-skeleton-kpis">
        {Array.from({ length: 4 }).map((_, i) => (
          <div className="page-skeleton-kpi" key={i}>
            <Skeleton width={92} height={12} />
            <Skeleton width={120} height={26} />
            <Skeleton width={68} height={14} />
          </div>
        ))}
      </div>
      <Panel>
        <div className="page-skeleton-toolbar">
          <Skeleton width={220} height={32} />
          <Skeleton width={132} height={32} />
          <Skeleton width={96} height={32} />
        </div>
        <SkeletonText lines={rows} gap={14} />
      </Panel>
    </div>
  );
}

/** 详情页骨架（主信息块 + 时间线） */
export function DetailPageSkeleton() {
  return (
    <div className="page-skeleton" aria-busy="true">
      <div className="page-skeleton-head">
        <Skeleton width={180} height={22} />
        <Skeleton width={300} height={13} />
      </div>
      <Panel>
        <SkeletonText lines={4} />
      </Panel>
      <Panel>
        <SkeletonText lines={6} />
      </Panel>
    </div>
  );
}

/** 表单页骨架 */
export function FormPageSkeleton() {
  return (
    <div className="page-skeleton" aria-busy="true">
      <div className="page-skeleton-head">
        <Skeleton width={160} height={22} />
      </div>
      <Panel>
        <div className="page-skeleton-form">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i}>
              <Skeleton width={72} height={12} />
              <Skeleton width="100%" height={34} />
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
